import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import { Button } from "devextreme-react/button";
import { useScreenSize } from "../../../utils/media-query";
import {
  RequestStatus,
  handleCheckDisableButton,
  changeDisplayedName,
  ApprovalStatus,
} from "../../../common";
import { useAuth } from "../../../contexts/auth";
import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";

export default function TimekeepingOnlineApprovalTableList({
  dataGrid,
  middleware,
  handleOpenPopup,
  approvalList,
  handleChangeSelectBox,
  filter,
  setFilter,
  handleSendApprove,
}) {
  const { isXSmall, isSmall } = useScreenSize();
  const { user } = useAuth();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [isDisable, setIsDisable] = React.useState(true);

  const selectionPopupChanged = ({ selectedRowsData }) => {
    setSelectedItems(selectedRowsData);
    handleCheckDisableButton(selectedRowsData, setIsDisable, user);
  };

  const renderActions = ({ data }) => {
    // 0: Reject
    // 1: Approve
    const newDataApprove = { ...data, type: 1, category: "TK" };
    const newDataReject = { ...data, type: 0, category: "TK" };
    return (
      <div>
        {data.ApprovalStatus !== 0 &&
        data.ApprovalStatus !== 1 &&
        (data.RequestStatus === 0 || data.RequestStatus === 1) ? (
          <div>
            <Button
              type="default"
              stylingMode="outlined"
              text={formatMessage("Approve")}
              onClick={() => handleSendApprove(newDataApprove)}
              className="button-rounded mr-2"
            />
            <Button
              type="danger"
              stylingMode="outlined"
              text={formatMessage("Reject")}
              className="button-rounded"
              // icon="close"
              onClick={() => handleOpenPopup(newDataReject)}
            />
          </div>
        ) : null}
      </div>
    );
  };
  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        dataSource={approvalList}
        ref={(e) => (dataGrid.current = e)}
        onSelectionChanged={selectionPopupChanged}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {middleware && middleware.ApproveState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"
            hidingPriority={isXSmall ? 15 : false}
          />
        )}
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="EmployeeCode"
          dataType="string"
        />
        <Column
          caption={formatMessage("EmployeeName")}
          dataField="FullName"
          dataType="string"
        />
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Department"
          dataType="string"
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Position"
          dataType="string"
        />
        <Column
          caption={formatMessage("ShiftName")}
          dataField="ShiftCode"
          dataType="string"
        />
        <Column
          caption={formatMessage("Date")}
          dataField="Date"
          dataType="date"
          format="dd/MM/yyyy"
        />
        <Column
          caption={formatMessage("LogTime")}
          dataField="Time"
          dataType="time"
          // format="dd/MM/yyyy"
        />

        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          hidingPriority={isXSmall ? 7 : false}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("CancelReason")}
          dataField="CancelReason"
          dataType="string"
          hidingPriority={isXSmall ? 7 : false}
        />
        <Column
          caption={formatMessage("CanceledDate")}
          dataField="CanceledDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall ? 8 : false}
        />
        <Column
          caption={formatMessage("ApprovalStatus")}
          dataField="ApprovalStatus"
          hidingPriority={isXSmall ? 8 : false}
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          dataType="string"
          hidingPriority={isXSmall ? 8 : false}
        />
        <Column
          caption={formatMessage("Approver")}
          dataField="LastApprovalName"
          dataType="string"
          hidingPriority={isXSmall ? 8 : false}
        />
        <Column
          caption={formatMessage("ApprovedDate")}
          dataField="ApprovedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall ? 13 : false}
        />
        <Column
          caption={formatMessage("ApprovalComments")}
          dataField="ApprovalComments"
          dataType="string"
          hidingPriority={isXSmall ? 11 : false}
        />
        <Toolbar>
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              selectedItems={selectedItems}
              middleware={middleware}
              handleOpenPopup={handleOpenPopup}
              dataGrid={dataGrid}
              isDisable={isDisable}
              handleSendApprove={handleSendApprove}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
